import NotificationManageService from "@/services/NotificationManageService";

export const notificationNavbarStore = {
    namespaced: true,
    state: {
        listNotificationNavbar: [],
        totalCountNotification: 0,
        openSubMenu: [],
        activeMenuIndex: "",
        parentFeedback: 0,
        teacherFeedback: 0,
        parentMessage: 0,
        medicationInstructions: 0,
        leaveStudent: 0,
        commentStudent: 0,
        pictureAlbum: 0,
        tuitionV4: 0,
        tuitionClass: 0,
        tuitionGroup: 0,
        payroll: 0,
        leavePersonnel: 0,
        paymentVouchers: 0,
        receipts: 0,
        studentBirthday: 0,
        parentBirthday: 0,
        employeeBirthday: 0,
        SMSHistory: 0,
        appNotificationHistory: 0,
    },

    getters: {

    },

    mutations: {
        SET_ACTIVE_MENU_INDEX: (state, data) => {
            state.activeMenuIndex = data;
        },

        SET_OPEN_SUBMENU: (state, data) => {
            state.openSubMenu = Array.isArray(data) ? data : (data ? [data] : []);
        },

        SET_LIST_NOTIFICATION: (state, data) => {
            state.listNotificationNavbar = data;
        },

        SET_TOTAL_COUNT_NOTIFICATION: (state, count) => {
            state.totalCountNotification = count;
        },

        SET_Parent_Feedback: (state, count) => {
            state.parentFeedback = count;
        },

        SET_Teacher_Feedback: (state, count) => {
            state.teacherFeedback = count;
        },

        SET_Parent_Message: (state, count) => {
            state.parentMessage = count;
        },

        SET_Medication_Instructions: (state, count) => {
            state.medicationInstructions = count;
        },

        SET_Leave_Student: (state, count) => {
            state.leaveStudent = count;
        },

        SET_Comment_Student: (state, count) => {
            state.commentStudent = count;
        },

        SET_Picture_Album: (state, count) => {
            state.pictureAlbum = count;
        },

        SET_Tuition_V4: (state, count) => {
            state.tuitionV4 = count;
        },

        SET_Tuition_Class: (state, count) => {
            state.tuitionClass = count;
        },

        SET_Tuition_Group: (state, count) => {
            state.tuitionGroup = count;
        },

        SET_Payroll: (state, count) => {
            state.payroll = count;
        },

        SET_Leave_Personnel: (state, count) => {
            state.leavePersonnel = count;
        },

        SET_Payment_Vouchers: (state, count) => {
            state.paymentVouchers = count;
        },

        SET_Receipts: (state, count) => {
            state.receipts = count;
        },

        SET_Student_Birthday: (state, count) => {
            state.studentBirthday = count;
        },

        SET_Parent_Birthday: (state, count) => {
            state.parentBirthday = count;
        },

        SET_Employee_Birthday: (state, count) => {
            state.employeeBirthday = count;
        },

        SET_SMSHistory: (state, count) => {
            state.SMSHistory = count;
        },

        SET_AppNotification_History: (state, count) => {
            state.appNotificationHistory = count;
        },
    },

    actions: {
        fetchNotification: ({commit, dispatch}) => {
            NotificationManageService.notificationNavbar()
                .then((res) => {
                    const data = res.data.data;
                    commit("SET_TOTAL_COUNT_NOTIFICATION", data.total);
                    commit("SET_LIST_NOTIFICATION", data.detailResponseList);
                    dispatch("setStoreNotification", data.detailResponseList);
                })
                .catch((err) => {
                    console.log(err.data.message);
                    dispatch("resetData");
                })
        },

        setStoreNotification: ({commit}, dataNotification) => {
            commit("SET_Tuition_V4", 0);
            commit("SET_Tuition_Class", 0);
            commit("SET_Tuition_Group", 0);
            if (dataNotification) {
                for (let i = 0; i <= dataNotification.length; i++) {
                    switch (dataNotification[i]?.nameIcon) {
                        case "Phụ huynh góp ý":
                            commit("SET_Parent_Feedback", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Giáo viên góp ý":
                            commit("SET_Teacher_Feedback", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Lời nhắn":
                            commit("SET_Parent_Message", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Dặn thuốc":
                            commit("SET_Medication_Instructions", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Xin nghỉ":
                            commit("SET_Leave_Student", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Nhận xét":
                            commit("SET_Comment_Student", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Album ảnh":
                            commit("SET_Picture_Album", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Thu học phí":
                            commit("SET_Tuition_V4", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Thu học phí theo lớp":
                            commit("SET_Tuition_Class", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Thu học phí theo nhóm":
                            commit("SET_Tuition_Group", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Bảng lương":
                            commit("SET_Payroll", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Xin nghỉ nhân sự":
                            commit("SET_Leave_Personnel", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Quản lý phiếu chi":
                            commit("SET_Payment_Vouchers", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Quản lý phiếu thu":
                            commit("SET_Receipts", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Sinh nhật học sinh":
                            commit("SET_Student_Birthday", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Sinh nhật phụ huynh":
                            commit("SET_Parent_Birthday", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Sinh nhật nhân viên":
                            commit("SET_Employee_Birthday", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Lịch sử nhắn tin SMS":
                            commit("SET_SMSHistory", dataNotification[i]?.totalDetailIcon);
                            break;

                        case "Lịch sử thông báo App":
                            commit("SET_AppNotification_History", dataNotification[i]?.totalDetailIcon);
                            break;
                    }
                }
            }
        },

        handleActiveSubmenu: ({commit}, {menuIndex, menuItemIndex}) => {
            commit("SET_OPEN_SUBMENU", menuIndex);
            commit("SET_ACTIVE_MENU_INDEX", menuItemIndex);
        },

        resetData({commit}) {
            commit("SET_LIST_NOTIFICATION", []);
            commit("SET_TOTAL_COUNT_NOTIFICATION", 0);
            commit("SET_Parent_Feedback", 0);
            commit("SET_Teacher_Feedback", 0);
            commit("SET_Parent_Message", 0);
            commit("SET_Medication_Instructions", 0);
            commit("SET_Leave_Student", 0);
            commit("SET_Comment_Student", 0);
            commit("SET_Picture_Album", 0);
            commit("SET_Tuition_V4", 0);
            commit("SET_Tuition_Class", 0);
            commit("SET_Tuition_Group", 0);
            commit("SET_Payroll", 0);
            commit("SET_Leave_Personnel", 0);
            commit("SET_Payment_Vouchers", 0);
            commit("SET_Receipts", 0);
            commit("SET_Student_Birthday", 0);
            commit("SET_Parent_Birthday", 0);
            commit("SET_Employee_Birthday", 0);
            commit("SET_SMSHistory", 0);
            commit("SET_AppNotification_History", 0);
            commit("SET_OPEN_SUBMENU", []);
            commit("SET_ACTIVE_MENU_INDEX", "");
        }
    }
}
